(function () {
  function initL60Faq() {
    var root = document.querySelector('.l60-series-faq');
    if (!root) return;
    var items = root.querySelectorAll('.p-faq-item');
    if (!items.length) return;

    // 默认仅第一个展开（若 JSON 已加 is-active 则保持，否则强制设置）
    var hasActive = root.querySelector('.p-faq-item.is-active');
    if (!hasActive) items[0].classList.add('is-active');

    function setMaxHeight(item) {
      var ans = item.querySelector('.p-faq-answer');
      if (!ans) return;
      ans.style.setProperty('--faq-answer-h', ans.scrollHeight + 'px');
    }

    items.forEach(function (item) {
      // 初始化已展开项的高度
      if (item.classList.contains('is-active')) setMaxHeight(item);

      var question = item.querySelector('.p-faq-question');
      if (!question) return;
      question.addEventListener('click', function () {
        var willOpen = !item.classList.contains('is-active');

        // 手风琴效果：关闭其他项（如果不需要可删掉这段）
        items.forEach(function (other) {
          if (other !== item) other.classList.remove('is-active');
        });

        if (willOpen) {
          setMaxHeight(item);
          item.classList.add('is-active');
        } else {
          item.classList.remove('is-active');
        }
      });
    });

    // 窗口尺寸变化时刷新当前展开项的高度
    window.addEventListener('resize', function () {
      var active = root.querySelector('.p-faq-item.is-active');
      if (active) setMaxHeight(active);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initL60Faq);
  } else {
    initL60Faq();
  }
})();